const BACKEND = process.env.REACT_APP_BACKEND_URL;

export function resolveImage(url) {
  if (!url) return null;
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  return `${BACKEND}${url}`;
}
